import { useEffect, useCallback, useRef } from 'react';
import './Modal.css';

// Track modal stack for proper escape key and body scroll handling
let modalStack = [];

export default function Modal({
  isOpen,
  onClose,
  title,
  children,
  size = 'medium',
  showClose = true
}) {
  const modalId = useRef(Math.random().toString(36).substr(2, 9));

  // Close on escape key - only close the topmost modal
  const handleEscape = useCallback((e) => {
    if (e.key === 'Escape') {
      // Only close if this is the topmost modal
      if (modalStack[modalStack.length - 1] === modalId.current) {
        onClose();
      }
    }
  }, [onClose]);

  useEffect(() => {
    if (isOpen) {
      modalStack.push(modalId.current);
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      const index = modalStack.indexOf(modalId.current);
      if (index > -1) {
        modalStack.splice(index, 1);
      }
      document.removeEventListener('keydown', handleEscape);
      // Only restore scroll if no more modals are open
      if (modalStack.length === 0) {
        document.body.style.overflow = '';
      }
    };
  }, [isOpen, handleEscape]);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className={`modal-container modal-${size}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h2 className="modal-title">{title}</h2>
          {showClose && (
            <button className="modal-close" onClick={onClose} aria-label="Close">
              &times;
            </button>
          )}
        </div>
        <div className="modal-content">
          {children}
        </div>
      </div>
    </div>
  );
}
